<script>
	export default {
		name: 'AppExecuter',
		methods: {
			getAppContents(key) {
				const self_ = this;
				const contents_ = self_.getContentsState('app')
				if(self_.isFalse(contents_)) { return {} }
				return contents_[key]
			},
			getAppInits(key) {
				const self_ = this;
				const inits_ = self_.getInitsState('app')
				if(self_.isFalse(inits_)) { return {} }
				return inits_[key]
			},
			setAppContents(key, value) {
				const self_ = this;
				self_.setContentsState('app', key, value)
			},
			setAppInits(key, value) {
				const self_ = this;
				self_.setInitsState('app', key, value)
			},
			initializeApp(appName) {
				const self_ = this;

				const dataTypes_ = ['contents', 'inits']

				let promiseArray_ = []

				dataTypes_.forEach(dataType => {
					promiseArray_.push(self_.$_appExec_setAppData(appName, dataType))
				})

				return Promise.all(promiseArray_)
			},
			$_appExec_setAppData(appName, dataType) {
				const self_ = this;

				const default_ = self_.$_appExec_getDefault(appName, dataType)

				let result_ = {}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubCollection(dataType, 'app', appName)
					}).then(result => {
						if(self_.isEmpty(result)) {
							result_ = default_
						} else {
							result_ = self_.$_appExec_mergeDefault(default_, result)
						}

						self_.$_appExec_setAppState(dataType, appName, result_)

						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: setAppData(' + appName + ', ' + dataType + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			$_appExec_getDefault(appName, dataType) {
				const self_ = this;
				
				let type_ = null;

				if(self_.isFalse(appName)) { type_ = 'default_' }
				else { type_ = appName + '_' }

				const nameState_ = self_.$_appExec_getAppState(dataType, appName)
				const typeState_ = self_.$_appExec_getAppState(dataType, type_)
				const defaultState_ = self_.$_appExec_getAppState(dataType, 'default_')
				
				if(self_.isObject(nameState_)) { return nameState_; }
				else if(self_.isObject(typeState_)) { return typeState_; }
				else { return defaultState_ }
			},
			$_appExec_mergeDefault(defaultObj, resultObj) {
				Object.keys(resultObj).forEach(key => {
					if(defaultObj[key]) {
						Object.keys(resultObj[key]).forEach(subKey => {
							defaultObj[key][subKey] = resultObj[key][subKey]
						})
					} else {
						defaultObj[key] = resultObj[key]
					}
				})

				return defaultObj
			},
			$_appExec_getAppState(dataType, key) {
				const self_ = this;
				
				if(dataType == 'contents') { return self_.getAppContents(key) }
				if(dataType == 'inits') { return self_.getAppInits(key) }
			},
			$_appExec_setAppState(dataType, key, value) {
				const self_ = this;
				
				if(dataType == 'contents') { self_.setAppContents(key, value) }
				if(dataType == 'inits') { self_.setAppInits(key, value) }
			}
		}
	}
</script>